import { commonmodel } from '../../shared/commonmodel';

export class UserMaster extends commonmodel {
    public intAdminUserID: number;
    public strUserName: '';
    public strEmailID: '';
    public strMobileNo: '';
    public strPassword: '';
    public strUserType: '';
    public strAgencyName: '';
    public strOrganizationEntityName: '';
    public strSalt: '';
    public intRoleID: number;
    public intUserTypeID: number;
    public intSTDCodeID: number;
    public intDesignationID: number;
    public intDepartmentID: number;
    public strAgencyMasterID: number;
    public intAgencyMasterID: number;
    public intOrganizationEntityID: number;
    public intGeoStructureID: number;
    public intIDProofTypeID: number;
    public intAccountMasterID: '';
    public intUserPersonalDetailID: number;
    public dteLastLogin: '';
    public dteLastLogout: '';
    public isTwoFactorAuthentication: '';
    public intFailedLoginAttemptCount: '';
    public intCreatedBy: '';
    public dteCreatedOn: '';
    public intModifiedBy: '';
    public dteModifiedOn: '';
    public intIntegrationSysUserID: '';
    public intTransportModeID: '';
    public intClientID: '';
    public strKCUserID: '';
    public intIntegrationSysID: '';
    public bDeleted: boolean = true;
    public bActive: boolean = true;
    public status: boolean;
    public intActionType?: number;
    public strPowerBankNumber: number;
    public strPINNumber: number;
    public strRFID: number;
    public strPinCodeNo: number;
    public intAddressMasterID: number;
    public strIDProofUpload: '';
    public strProofUrl: '';
    public strOrganizationEntityID: '';
    public AfcsAdmin: any;
    public isPassDis: boolean;
    public dteDOB: string;
    public dteLicenceExpiry: string;

    public intCorporationID : number;
    public intBookingCenterID : number;
    public strZoneID ;
    public strDivisionID ;
    public strDepotID ;
    public intSystemID: any[] = [];

    public intUserID:number;
    UserMaster() {
        this.lan = 'en',
            this.datetimeformat = 'YYYY/MM/DD HH24:MI:SS'
    }
}


export class Uploadfile extends commonmodel {

    public strProfilePicture: '';
    public Images: '';
    public strHash: '';
}